import ACTIONS from "../constants/actions";

const {
  GET_SHIFT_TYPES,
  ADD_NEW_SHIFT,
  GET_SHIFT_TYPES_SUCCESS,
  GET_SHIFT_TYPES_FAIL,
  ADD_NEW_SHIFT_FAIL,
  ADD_NEW_SHIFT_SUCCESS,
  DELETE_SHIFT_TYPE,
  DELETE_SHIFT_TYPE_SUCCESS,
  DELETE_SHIFT_TYPE_FAIL,
  EDIT_SHIFT_TYPE,
  EDIT_SHIFT_TYPE_SUCCESS,
  EDIT_SHIFT_TYPE_FAIL,
  GET_SHIFT_TYPE_BY_ID,
  GET_SHIFT_TYPE_BY_ID_SUCCESS,
  GET_SHIFT_TYPE_BY_ID_FAIL,
  GET_ALL_SHIFTS,
  GET_ALL_SHIFTS_SUCCESS,
  GET_ALL_SHIFTS_FAIL,
  GET_SHIFT,
  GET_SHIFT_SUCCESS,
  GET_SHIFT_FAIL,
  EXPORT_CSV_REQUEST,
  EXPORT_CSV_SUCCESS,
  EXPORT_CSV_FAIL,
  GET_GENERATE_REQUEST,
  GET_GENERATE_SUCCESS,
  GET_GENERATE_FAIL,
  GET_SHIFT_SESIONS,
  GET_SHIFT_SESIONS_SUCCESS,
  GET_SHIFT_SESIONS_FAIL,
  GET_ALL_SHIFTS_OVERTIME,
  GET_ALL_SHIFTS_OVERTIME_SUCCESS,
  GET_ALL_SHIFTS_OVERTIME_FAIL,
  GET_ALL_BRANCH_REQUEST,
  GET_ALL_BRANCH_SUCCESS,
  GET_ALL_BRANCH_FAIL,
  GET_ALL_TEAM_REQUEST,
  GET_ALL_TEAM_SUCCESS,
  GET_ALL_TEAM_FAIL,
  GET_ALL_USER_REQUEST,
  GET_ALL_USER_SUCCESS,
  GET_ALL_USER_FAIL,
  CLEAR_FILTER_WORKED_SHIFT,
} = ACTIONS;

const initialState = {
  isLoadingShift: true,
  isLoadingAllUsers: false,
  isLoadingAllTeams: false,
  isLoadingAllBranches: false,
  isLoadingGetShiftOvertime: false,
  isLoadingShiftSessions: true,
  isLoadingGetShiftById: true,
  isLoadingGetGenerate: true,
  isLoadingGet: true,
  allShiftsOvertime: [],
  shiftsOvertimeTotalElements: 0,
  shiftsOvertimeTotalPages: 0,
  aShiftType: null,
  allShifts: [],
  shift: [],
  allSessions: [],
  allBranches: [],
  allTeams: [],
  allUsers: [],
  isLoadingModalShift: false,
  normalizeAllBranch: null,
  normalizeAllTeam: null,
};

const shiftPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHIFT_TYPES:
      return {
        ...state,
        isLoadingShift: true,
      };
    case GET_SHIFT_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingShift: false,
        shiftTypesTotalPages: action.payload.totalsPages,
        shiftTypesTotalElement: action.payload.totalElements,
      };
    case GET_SHIFT_TYPES_FAIL:
      return {
        ...state,
        isLoadingShift: false,
      };
    case GET_SHIFT_SESIONS:
      return {
        ...state,
        isLoadingShiftSessions: true,
      };
    case GET_SHIFT_SESIONS_SUCCESS:
      return {
        ...state,
        isLoadingShiftSessions: false,
        allSessions: action.payload,
      };
    case GET_SHIFT_SESIONS_FAIL:
      return {
        ...state,
        isLoadingShiftSessions: false,
      };

    case GET_SHIFT_TYPE_BY_ID:
      return {
        ...state,
        isLoadingGetShiftById: true,
      };
    case GET_SHIFT_TYPE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoadingGetShiftById: false,
        aShiftType: action.payload,
      };
    case GET_SHIFT_TYPE_BY_ID_FAIL:
      return {
        ...state,
        isLoadingGetShiftById: false,
      };
    case ADD_NEW_SHIFT:
      return {
        ...state,
        isLoadingModalShift: true,
      };
    case ADD_NEW_SHIFT_SUCCESS:
      return {
        ...state,
        isLoadingModalShift: false,
      };
    case ADD_NEW_SHIFT_FAIL:
      return {
        ...state,
        isLoadingModalShift: false,
      };
    case DELETE_SHIFT_TYPE:
      return {
        ...state,
        isLoadingModalShift: true,
      };
    case DELETE_SHIFT_TYPE_SUCCESS:
      return {
        ...state,
        isLoadingModalShift: false,
      };
    case DELETE_SHIFT_TYPE_FAIL:
      return {
        ...state,
        isLoadingModalShift: false,
      };
    case EDIT_SHIFT_TYPE:
      return {
        ...state,
        isLoadingModalShift: true,
      };
    case EDIT_SHIFT_TYPE_SUCCESS:
      return {
        ...state,
        isLoadingModalShift: false,
      };
    case EDIT_SHIFT_TYPE_FAIL:
      return {
        ...state,
        isLoadingModalShift: false,
      };
    case GET_ALL_SHIFTS:
      return {
        ...state,
        isLoadingGetShifts: true,
      };
    case GET_ALL_SHIFTS_SUCCESS:
      return {
        ...state,
        isLoadingGetShifts: false,
        allShifts: action.payload.contents,
        ShiftsTotalElements: action.payload.totalElements,
        ShiftsTotalPages: action.payload.totalPages,
      };
    case GET_ALL_SHIFTS_FAIL:
      return {
        ...state,
        isLoadingGetShifts: false,
      };
    case GET_ALL_SHIFTS_OVERTIME:
      return {
        ...state,
        isLoadingGetShiftOvertime: true,
      };
    case GET_ALL_SHIFTS_OVERTIME_SUCCESS:
      return {
        ...state,
        isLoadingGetShiftOvertime: false,
        allShiftsOvertime: action.payload.contents,
        shiftsOvertimeTotalElements: action.payload.totalElements,
        shiftsOvertimeTotalPages: action.payload.totalPages,
      };
    case GET_ALL_SHIFTS_OVERTIME_FAIL:
      return {
        ...state,
        isLoadingGetShiftOvertime: false,
      };
    case GET_SHIFT:
      return {
        ...state,
        isLoadingGetShiftById: true,
      };
    case GET_SHIFT_SUCCESS:
      return {
        ...state,
        isLoadingGetShiftById: false,
        shift: action.payload,
      };
    case GET_SHIFT_FAIL:
      return {
        ...state,
        isLoadingGetShiftById: false,
      };
    case EXPORT_CSV_REQUEST:
      return {
        ...state,
      };
    case EXPORT_CSV_SUCCESS:
      return {
        ...state,
      };
    case EXPORT_CSV_FAIL:
      return {
        ...state,
      };
    case GET_GENERATE_REQUEST:
      return {
        ...state,
        isLoadingGetShifts: true,
      };
    case GET_GENERATE_SUCCESS:
      return {
        ...state,
        allShifts: action.payload.contents,
        isLoadingGetShifts: false,
      };
    case GET_GENERATE_FAIL:
      return {
        ...state,
        isLoadingGetShifts: false,
      };
    case GET_ALL_BRANCH_REQUEST:
      return {
        ...state,
        isLoadingAllBranches: true,
      };
    case GET_ALL_BRANCH_SUCCESS:
      return {
        ...state,
        allBranches: action.payload,
        normalizeAllBranch: action.payload.reduce(
          (prev, cur) => ({ ...prev, [cur.code]: cur }),
          {}
        ),
        isLoadingAllBranches: false,
      };
    case GET_ALL_BRANCH_FAIL:
      return {
        ...state,
        isLoadingAllBranches: false,
      };
    case GET_ALL_TEAM_REQUEST:
      return {
        ...state,
        isLoadingAllTeams: true,
      };
    case GET_ALL_TEAM_SUCCESS:
      return {
        ...state,
        allTeams: action.payload,
        normalizeAllTeam: action.payload.reduce(
          (prev, cur) => ({ ...prev, [cur.code]: cur }),
          {}
        ),
        isLoadingAllTeams: false,
      };
    case GET_ALL_TEAM_FAIL:
      return {
        ...state,
        isLoadingAllTeams: false,
      };
    case GET_ALL_USER_REQUEST:
      return {
        ...state,
        isLoadingAllUsers: true,
      };
    case GET_ALL_USER_SUCCESS:
      return {
        ...state,
        allUsers: action.payload,
        isLoadingAllUsers: false,
      };
    case GET_ALL_USER_FAIL:
      return {
        ...state,
        isLoadingAllUsers: false,
      };
    case CLEAR_FILTER_WORKED_SHIFT:
      return {
        ...state,
        allTeams: [],
        allUsers: [],
      };
    default:
      return state;
  }
};
export default shiftPageReducer;
